import React from "react";
import assetimages from "./assetimages";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

export default class NavHeader extends React.Component {
  render() {
    return (
      <div className="app-header header" style={{ background: "#fff" }}>
        <div className="container-fluid">
          <div className="d-flex" style={{ alignItems: "center" }}>
            <label className="header-brand">
              <img
                src={assetimages.logo}
                className="header-brand-img desktop-lgo"
                alt=""
                style={{ height: "3.5rem" }}
              />
              <img
                src={assetimages.logo}
                className="header-brand-img desktop-lgo"
                alt="logo"
                style={{ display: "block" }}
              />
            </label>
            <div
              className="app-sidebar__toggle"
              onClick={() => {
                document
                  .getElementById("app")
                  .classList.toggle("sidenav-toggled");
              }}
            >
              <label className="open-toggle">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-align-left header-icon mt-1"
                >
                  <line x1="17" y1="10" x2="3" y2="10"></line>
                  <line x1="21" y1="6" x2="3" y2="6"></line>
                  <line x1="21" y1="14" x2="3" y2="14"></line>
                  <line x1="17" y1="18" x2="3" y2="18"></line>
                </svg>
              </label>
            </div>
            <div className="mt-auto mb-auto ml-auto">
              <span className="badge badge-success side-badge">
                {localStorage.getItem("username")}
              </span>
            </div>
            <div className="d-flex order-lg-2 ml-2 float-right">
              <div className="dropdown   header-fullscreen">
                <label
                  className="nav-link icon full-screen-link p-0"
                  onClick={() => {
                    localStorage.clear();
                    this.props.history.push("/login");
                  }}
                >
                  <svg
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    className="header-icon"
                    width="16"
                    height="16"
                    viewBox="0 0 575.279 575.279"
                    style={{ enableBackground: "new 0 0 575.279 575.279" }}
                  >
                    <g>
                      <g>
                        <path
                          d="M287.64,575.279c158.86,0,287.639-128.779,287.639-287.639C575.279,128.78,446.5,0,287.64,0S0,128.78,0,287.641
			C0,446.5,128.78,575.279,287.64,575.279z M324.557,78.856v83.917v106.169c0,20.389-16.527,36.916-36.917,36.916
			c-20.389,0-36.916-16.527-36.916-36.916V162.771V78.856c0-3.592,0.539-7.053,1.497-10.337
			c4.474-15.352,18.623-26.579,35.422-26.579c16.8,0,30.949,11.227,35.423,26.579C324.018,71.8,324.557,75.264,324.557,78.856z
			 M226.48,74.211c-0.116,1.539-0.236,3.075-0.236,4.645v93.755c-42.415,22.206-71.438,66.631-71.438,117.736
			c0,73.244,59.59,132.836,132.834,132.836c73.245,0,132.834-59.592,132.834-132.836c0-51.102-29.023-95.53-71.439-117.736V78.856
			c0-1.567-0.119-3.106-0.234-4.645c94.324,26.643,163.475,113.284,163.475,216.136c0,124.062-100.574,224.635-224.635,224.635
			c-124.062,0-224.635-100.572-224.635-224.635C63.005,187.496,132.155,100.852,226.48,74.211z"
                        />
                      </g>
                    </g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                  </svg>
                </label>
              </div>
              <div className="dropdown   header-fullscreen">
                <Link className="nav-link icon full-screen-link p-0" to="/home">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="header-icon"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 3.293l6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                    ></path>
                    <path
                      fillRule="evenodd"
                      d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
                    ></path>
                  </svg>
                </Link>
              </div>
              <Dropdown className=" profile-dropdown">
                <Dropdown.Toggle
                  as={"label"}
                  className="nav-link pr-0 leading-none mb-0"
                >
                  <span>
                    <img
                      src={assetimages.usericon}
                      alt="img"
                      className="avatar avatar-md brround"
                    />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className=" dropdown-menu-right dropdown-menu-arrow animated">
                  <div className="text-center">
                    <Dropdown.Item
                      className="text-center user pb-0 mb-0 font-weight-bold"
                      as={"Label"}
                    >
                      001
                    </Dropdown.Item>
                    <Dropdown.Divider />
                  </div>
                  <Dropdown.Item
                    as={Link}
                    className="dropdown-item d-flex"
                    to="/profile"
                  >
                    <svg
                      className="header-icon2nd mr-3"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M0 0h24v24H0V0z" fill="none"></path>
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20s-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"></path>
                    </svg>
                    <div className="">Profile</div>
                  </Dropdown.Item>
                  <Dropdown.Item
                    as={Link}
                    className=" d-flex"
                    to="/changepassword/login"
                  >
                    <i
                      className="icon-lock mr-3"
                      style={{ marginTop: "2px" }}
                    ></i>
                    <div className="">Change Password</div>
                  </Dropdown.Item>

                  <Dropdown.Item as={"label"} className="d-flex">
                    <svg
                      className="header-icon2nd mr-3"
                      xmlns="http://www.w3.org/2000/svg"
                      enableBackground="new 0 0 24 24"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <g>
                        <rect fill="none" height="24" width="24"></rect>
                      </g>
                      <g>
                        <path d="M11,7L9.6,8.4l2.6,2.6H2v2h10.2l-2.6,2.6L11,17l5-5L11,7z M20,19h-8v2h8c1.1,0,2-0.9,2-2V5c0-1.1-0.9-2-2-2h-8v2h8V19z"></path>
                      </g>
                    </svg>
                    <div
                      className=""
                      onClick={() => {
                        localStorage.clear();
                        this.props.history.push("/login");
                      }}
                    >
                      Sign Out
                    </div>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
